module.exports = __webpack_public_path__ + "img/youmu konpaku mysterious sword master_lw.4324a2a0.png";